/**
 * UseOnlyNotice — REQ-AGT-003 (enmienda 14-Oct-2026).
 *
 * La UI del editor NO cambia de estructura en modo `use_only`: las secciones
 * de definición del publisher se sustituyen por este aviso (no disponible
 * según los términos y condiciones), manteniendo visibles las secciones de
 * configuración propia del tenant.
 */

import { Card } from '@/components/ui';
import { ShieldAlert } from 'lucide-react';
import { useI18n } from '@/i18n';

export function UseOnlyNotice({ section }: { section: string }) {
  const { t } = useI18n();
  return (
    <Card className="p-6">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-lg bg-blue-100 dark:bg-blue-900 flex items-center justify-center shrink-0">
          <ShieldAlert size={24} className="text-blue-600 dark:text-blue-400" />
        </div>
        <div className="space-y-2">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            {t('admin.agents.editor.useOnly.noticeTitle') ||
              'Not available under the terms and conditions'}
          </h2>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            {t('admin.agents.editor.useOnly.noticeDescription', { section }) ||
              `The ${section} configuration belongs to the platform publisher and is not available under the terms and conditions. You can still use this agent and connect your own resources in the sections below.`}
          </p>
          <span className="inline-flex items-center rounded-full bg-blue-50 dark:bg-blue-900/40 px-2.5 py-0.5 text-xs font-medium text-blue-700 dark:text-blue-300">
            {t('admin.agents.editor.useOnly.badge') || 'Platform managed'}
          </span>
        </div>
      </div>
    </Card>
  );
}
